/**
 * Espelho do registro de tipos de alerta do backend
 * (backend/src/domain/constants/system-alert-templates.ts).
 * Front e back têm builds separados, então este arquivo precisa ser
 * mantido manualmente em sincronia com o backend ao adicionar/alterar tipos.
 */
export interface SystemAlertTemplateDef {
    alias: string;
    icon: string;
    color: string;
    requiresVehicle: boolean;
    category: 'CAMERA' | 'EQUIPMENT' | 'SERVICE' | 'SHIFT' | 'VEHICLE';
    deprecated?: boolean;
}

export const SYSTEM_ALERT_TEMPLATES: Record<string, SystemAlertTemplateDef> = {
    CAMERA_ON: {
        alias: 'Câmera Ligada',
        icon: 'videocam',
        color: '#22c55e',
        requiresVehicle: true,
        category: 'EQUIPMENT',
    },
    CAMERA_OFF: {
        alias: 'Câmera Desligada',
        icon: 'videocam_off',
        color: '#ef4444',
        requiresVehicle: true,
        category: 'EQUIPMENT',
    },
    VEHICLE_MOVING: {
        alias: 'Veículo em Movimento',
        icon: 'directions_car',
        color: '#22c55e',
        requiresVehicle: true,
        category: 'VEHICLE',
    },
    VEHICLE_STOPPED: {
        alias: 'Veículo parado',
        icon: 'local_parking',
        color: '#f59e0b',
        requiresVehicle: true,
        category: 'VEHICLE',
    },
    SERVICE_OPENED: {
        alias: 'Ocorrência Aberta',
        icon: 'assignment',
        color: '#3b82f6',
        requiresVehicle: true,
        category: 'SERVICE',
    },
    VITALS_MEASURING: {
        alias: 'Monitores Vitais Medindo',
        icon: 'monitor_heart',
        color: '#22c55e',
        requiresVehicle: true,
        category: 'EQUIPMENT',
        deprecated: true,
    },
    SERVICE_PENDING_CLOSURE: {
        alias: 'Atendimento Pendente de Encerramento',
        icon: 'pending_actions',
        color: '#f59e0b',
        requiresVehicle: true,
        category: 'SERVICE',
    },
    SERVICE_CLOSED: {
        alias: 'Ocorrência Fechada',
        icon: 'assignment_turned_in',
        color: '#6b7280',
        requiresVehicle: true,
        category: 'SERVICE',
    },
    EQUIPMENT_DOWN: {
        alias: 'Equipamento Inoperante',
        icon: 'report_problem',
        color: '#ef4444',
        requiresVehicle: true,
        category: 'EQUIPMENT',
    },
    EQUIPMENT_RESTORED: {
        alias: 'Equipamento Reestabelecido',
        icon: 'check_circle',
        color: '#22c55e',
        requiresVehicle: true,
        category: 'EQUIPMENT',
    },
    SHIFT_OPENED: {
        alias: 'Turno Aberto',
        icon: 'groups',
        color: '#3b82f6',
        requiresVehicle: false,
        category: 'SHIFT',
    },
    INTEGRATION_SYNC_DEGRADED: {
        alias: 'Integração com Falha de Sincronização',
        icon: 'sync_problem',
        color: '#ef4444',
        requiresVehicle: false,
        category: 'VEHICLE',
    },
    INTEGRATION_SYNC_RESTORED: {
        alias: 'Integração Sincronizando Novamente',
        icon: 'sync',
        color: '#22c55e',
        requiresVehicle: false,
        category: 'VEHICLE',
    },
};

export type SystemAlertType = keyof typeof SYSTEM_ALERT_TEMPLATES;

export function getSystemAlertTemplate(type: string): SystemAlertTemplateDef {
    return SYSTEM_ALERT_TEMPLATES[type] || { alias: type, icon: 'notifications', color: '#2196F3', requiresVehicle: true, category: 'EQUIPMENT' };
}
